<template>
    <div class="LkStudents">
        <SideMenu />
        <MobileHeaderMenu />
        <router-view/>
    </div>
</template>

<script>
import SideMenu from "@/components/SideMenu/SideMenu.vue"
import MobileHeaderMenu from "@/components/MobileHeaderMenu/index.vue"
import 'splitpanes/dist/splitpanes.css'
import './index.scss';

export default {
    name: 'lkstudents',
    components: {
        SideMenu,
        MobileHeaderMenu
    },
}
</script>

<style>

</style>